import styled from "styled-components";
import { TextField as MuiTextField } from "@mui/material";

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 4px;
`;

export const RadioSingleContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  background-color: #f7f9fd;
  font-size: 14px;
  padding-right: 20px;
  border-radius: 6px;
`;

export const Radio = styled.input`
  display: inline-block;
  position: absolute;
  top: 17px;
  left: 10px;
  cursor: pointer;
  appearance: none;
  margin-top: -3px;
  // vertical-align: middle;
  border: ${({ theme }) => `2px solid ${theme.colors.GREY_EXTRA_HEAVY}`};
  border-radius: 50%;
  width: 20px;
  height: 20px;

  :checked {
    border: ${({ theme }) => `6px solid ${theme.colors.BLUE_HEAVY}`};
  }
`;

export const Label = styled.label<{ isFocused: boolean }>`
  display: inline-block;
  align-items: center;
  cursor: pointer;
  padding: 15px 20px 14px 42px;
  width: calc(100% - 40px);
  border-radius: 6px;
  background-color: ${({ isFocused }) => (isFocused ? "#edeff9" : "#f7f9fd")};
  border: 1px solid ${({ isFocused }) => (isFocused ? "#4553fb" : "transparent")};
`;

export const TextField = styled(MuiTextField)`
  width: 200px;

  div {
      font-size: 14px;
      height: 10px;
      margin-top: 9px;
      padding-bottom: 9px;

    ::before {
      border-bottom: ${({ theme }) => `1px solid ${theme.colors.GREY_HEAVY}`} !important;
    }

    ::after {
      border-bottom: ${({ theme }) => `2px solid ${theme.colors.BLUE_HEAVY}`};
    }
  }
`;
